import { addDoc, collection } from "firebase/firestore";
import { db } from "../../..";


export const addUser = async ({ name, email, topValues }) => {
  await addDoc(collection(db, "users", ), {
    name: name,
    email: email,
    topValues: topValues,
  }).catch((err) => {
    //console.log(err);
  });
};
